import axios from 'axios'
import { StorageFactory } from './storageFactory'

export const localStore = StorageFactory(() => localStorage)

export const HTTP_WITHOUT_HEADER = () => {
  let origin = window.location.origin
  if(origin.indexOf(':8')>0){ 
    origin = origin.substring(0,origin.indexOf(':8'))
  }
//  origin = "https://new.pragyasystems.com"
  return axios.create({
    baseURL: origin + '/'
  })
}

export const HTTP = (token) => {
  let origin = window.location.origin
  if(origin.indexOf(':8')>0){
    origin = origin.substring(0,origin.indexOf(':8'))
  }
//  origin = "https://new.pragyasystems.com"
  if (token !== undefined) {
    return axios.create({
      baseURL: origin + '/',
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
  } else if (localStore.getItem('token')) {
    return axios.create({
      baseURL: origin + '/',
      headers: {
        Authorization: 'Bearer ' + localStore.getItem('token')
      }
    })
  } else {
    if(window.location.host.indexOf('capsicohealth') == -1){
      window.location.href = '/vue/#/login'
    }else{
        let currentUrl = encodeURIComponent(window.location.href)
        let host = window.location.host
        let currentUrl1 = window.location.href

        if(currentUrl1.indexOf('vue/#/login') !=-1){
            currentUrl = encodeURIComponent('https://'+host+'/vue/#/dashboard/modern')
        } 
          if(host && (host.indexOf('capsicohealth') !=-1)){
            if(host.indexOf('demo.') !=-1){
              let loginUrl = 'https://genailearning-demo.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
              window.location.href = loginUrl
            }else{
              let loginUrl = 'https://genailearning.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
              window.location.href = loginUrl
            }
          }
    }
//    window.location.href = (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1) ? '/landing/views/nunav-landing.html' : '/landing/views/login.html'
  }
}

export const HTTP_FIREBASE_SHORTLINK = () => {
  return axios.create({
    baseURL: 'https://firebasedynamiclinks.googleapis.com/',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const sortObjects = (objects, key, reverse = false) => {
  /*
  Sorts a list of objects based on the value of their key property
   */
  let sortedKeys = Object.keys(objects).sort((a, b) => {
    if (reverse) return objects[b][key] - objects[a][key]
    return objects[a][key] - objects[b][key]
  })

  return sortedKeys.map((k) => {
    return objects[k]
  })
}

export const handleSessionExpired = (error) => {
        let currentUrl = encodeURIComponent(window.location.href)
        let host = window.location.host
        let currentUrl1 = window.location.href

        if(currentUrl1.indexOf('vue/#/login') !=-1){
            currentUrl = encodeURIComponent('https://'+host+'/vue/#/dashboard/modern')
        } 
      if(host && (host.indexOf('capsicohealth') !=-1)){
          if(host.indexOf('demo') !=-1){
            let loginUrl = 'https://genailearning-demo.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
            window.location.href = loginUrl
          }else{
            let loginUrl = 'https://genailearning.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
            window.location.href = loginUrl
          }
      }else{
          let currentUrl = window.location.href
          if(currentUrl.indexOf('/vue/#/login')==-1){
            let baseUrl = window.location.origin
            let loginUrl = baseUrl+'/vue/#/login'
            window.location.href = loginUrl
          }
      }
}



// WEBPACK FOOTER //
// ./src/utils.js